<script setup lang="ts">
import TagsPage from '~/pages/tags.vue'
import TagIcon from '../components/ui/TagIcon.vue'
// import { useNuxtApp } from '#app'
const vm = useVmStore()

const isMobileView = ref(false);
const checkMobileView = () => {
  isMobileView.value = window.innerWidth <= 750 && vm.isMobile;
}
onMounted(() => {
  
  checkMobileView(); // Initial check
  window.addEventListener('resize', checkMobileView);
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobileView);
})
</script>

<template>
  <div class="flex flex-col  p-2 pl-0 space-y-2" :class=" isMobileView ? 'w-full h-[calc(100vh-143px)]' : 'w-72 h-[calc(100vh-80px)]'">

    <!-- NAV CARD -->
    <section
      class="flex-1 overflow-y-auto bg-neutral rounded-lg p-2 shadow-sm"
    >
      <nav class="w-full">
        <ul class="flex flex-col space-y-1">
          <!-- Discover Header -->
          <li>
            <div class="flex items-center mb-2">
              <div class="flex-1 h-[2px] bg-gradient-to-r from-transparent to-[#00ccaa]" />
              <span class="mx-4 text-lg font-bold text-[hsl(var(--accent))]">
                Discover
              </span>
              <div class="flex-1 h-[2px] bg-gradient-to-l from-transparent to-[#00ccaa]" />
            </div>
          </li>
        </ul>
        <div class="grid grid-cols-4 gap-x-0.5 gap-y-2">
         <TagIcon imgname="tag-transformers" tagname="Transformers" />
         <TagIcon imgname="tag-textgen" tagname="Text Generation" />
     <!--Not showing: Featured, Conference, Dev, Finance, Presenting, Security, Sheets, Travel-->
         <TagIcon imgname="tag-featured" tagname="Featured"/>
         <TagIcon imgname="tag-ai" tagname="AI"/>
         <TagIcon imgname="tag-art" tagname="Art"/>
         <TagIcon imgname="tag-calendar" tagname="Calendar"/>
         <TagIcon imgname="tag-chat" tagname="Chat"/>
         <TagIcon imgname="tag-conference" tagname="Conference"/>
         <TagIcon imgname="tag-dev" tagname="Dev"/>
         <TagIcon imgname="tag-documents" tagname="Documents"/>
         <TagIcon imgname="tag-education" tagname="Education"/>
         <TagIcon imgname="tag-email" tagname="Email"/> 
         <TagIcon imgname="tag-food" tagname="Food"/> 
         <TagIcon imgname="tag-music" tagname="Music"/>
         <TagIcon imgname="tag-news" tagname="News"/>
         <TagIcon imgname="tag-notes" tagname="Notes"/>
         <TagIcon imgname="tag-p2p" tagname="P2P"/>
         <TagIcon imgname="tag-photos" tagname="Photos"/>
         <TagIcon imgname="tag-podcasts" tagname="Podcasts"/>
         <TagIcon imgname="tag-presenting" tagname="Presenting"/>
         <TagIcon imgname="tag-reviews" tagname="Reviews"/>
         <TagIcon imgname="tag-security" tagname="Security"/>
         <TagIcon imgname="tag-sheets" tagname="Sheets"/>
         <TagIcon imgname="tag-shopping" tagname="Shopping"/>
         <TagIcon imgname="tag-social" tagname="Social"/>
         <TagIcon imgname="tag-storage" tagname="Storage"/>
         <TagIcon imgname="tag-travel" tagname="Travel"/>
         <TagIcon imgname="tag-video" tagname="Video"/>
        </div>
      </nav>
    </section>

    <!-- TAGS CARD -->
    <section
      class="bg-neutral rounded-lg p-2 shadow-lg" :class="isMobileView ? ' z-50' : 'block'"
    >
      <TagsPage />
    </section>
  </div>
</template>
 <!-- old Admin Links  
          <li v-if="vm.isAdmin">
            <NuxtLink
              to="/products"
              class="block px-3 py-1 rounded hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--secondary-content))] transition-colors"
            >Products</NuxtLink>
          </li>
          <li v-if="vm.isAdmin">
            <NuxtLink
              to="/torrentleech"
              class="block px-3 py-1 rounded hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--secondary-content))] transition-colors"
            >Leech Torrent</NuxtLink>
          </li>
          <li v-if="vm.isAdmin">
            <NuxtLink
              to="/torrentseed"
              class="block px-3 py-1 rounded hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--secondary-content))] transition-colors"
            >Seed Torrent</NuxtLink>
          </li>
          <li v-if="vm.isAdmin">
            <NuxtLink
              to="/feedback"
              class="block px-3 py-1 rounded hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--secondary-content))] transition-colors"
            >Show Feedback</NuxtLink>
          </li>
          <li v-if="vm.isAdmin">
            <NuxtLink
              to="/regenfeedbackindex"
              class="block px-3 py-1 rounded hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--secondary-content))] transition-colors"
            >Regenerate R2 Index</NuxtLink>
          </li>
        </ul>-->